import * as React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';

export interface IHelmetScript {
  content: string;
  attrs: Record<string, string>;
}

export interface IHelmetProps {
  scripts: IHelmetScript[];
}

export const Helmet = ({ scripts }: IHelmetProps) => (
  <ReactHelmet>
    {scripts.map(({ content, attrs }, i) => {
      return React.createElement(
        'script',
        {
          key: `s${i}`,
          ...attrs,
        },
        content,
      );
    })}
  </ReactHelmet>
);
